import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import { AnzPromocodeBannerComponent } from './promocode-banner-ui.component';

@NgModule({
  declarations: [AnzPromocodeBannerComponent],
  imports: [CommonModule, MarkdownModule],
  exports: [AnzPromocodeBannerComponent],
})
export class AnzPromocodeBannerUiModule {}
